<template>
<div class="chapter">
<div class="inner_page">
<div id="toc">
<h1 id="toc-title">The Da Calvi Legacy</h1>
<ol class="toc">
<li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-4"><a href="#/text/ch004#acknowledgement">Acknowledgement</a></li>
<li id="toc-li-5"><a href="#/text/ch005#part-one-central-italy-19391945">Part One: (Central Italy
          1939–1945)</a></li>
<li id="toc-li-6"><a href="#/text/ch006#section">
</a><ol class="toc"><a href="#/text/ch006#section">
</a><li id="toc-li-7"><a href="#/text/ch006#section"></a><a href="#/text/ch006#chapter-1-ernesto">Chapter 1: Ernesto</a></li>
</ol>
</li>
<li id="toc-li-8"><a href="#/text/ch007#section-1">
</a><ol class="toc"><a href="#/text/ch007#section-1">
</a><li id="toc-li-9"><a href="#/text/ch007#section-1"></a><a href="#/text/ch007#chapter-2-ennio-and-ernesto">Chapter 2: Ennio and Ernesto</a></li>
</ol>
</li>
<li id="toc-li-10"><a href="#/text/ch008#section-2">
</a><ol class="toc"><a href="#/text/ch008#section-2">
</a><li id="toc-li-11"><a href="#/text/ch008#section-2"></a><a href="#/text/ch008#chapter-3-elena">Chapter 3: Elena</a></li>
</ol>
</li>
<li id="toc-li-12"><a href="#/text/ch009#section-3">
</a><ol class="toc"><a href="#/text/ch009#section-3">
</a><li id="toc-li-13"><a href="#/text/ch009#section-3"></a><a href="#/text/ch009#chapter-4-andrea">Chapter 4: Andrea</a></li>
</ol>
</li>
<li id="toc-li-14"><a href="#/text/ch010#part-two-central-italy-present-day">Part Two: (Central Italy, Present
          Day)</a></li>
<li id="toc-li-15"><a href="#/text/ch011#section-4">
</a><ol class="toc"><a href="#/text/ch011#section-4">
</a><li id="toc-li-16"><a href="#/text/ch011#section-4"></a><a href="#/text/ch011#chapter-5-sebastiano-luce">Chapter 5: Sebastiano Luce</a></li>
</ol>
</li>
<li id="toc-li-17"><a href="#/text/ch012#section-5">
</a><ol class="toc"><a href="#/text/ch012#section-5">
</a><li id="toc-li-18"><a href="#/text/ch012#section-5"></a><a href="#/text/ch012#chapter-6-francesco">Chapter 6: Francesco</a></li>
</ol>
</li>
<li id="toc-li-19"><a href="#/text/ch013#section-6">
</a><ol class="toc"><a href="#/text/ch013#section-6">
</a><li id="toc-li-20"><a href="#/text/ch013#section-6"></a><a href="#/text/ch013#chapter-7-ennio-and-francesco">Chapter 7: Ennio and Francesco</a>
</li>
</ol>
</li>
<li id="toc-li-21"><span href="#/text/ch014#section-7" title="Link target outside of Sample">
</span><ol class="toc"><span href="#/text/ch014#section-7" title="Link target outside of Sample">
</span><li id="toc-li-22"><span href="#/text/ch014#section-7" title="Link target outside of Sample"></span><span href="#/text/ch014#chapter-8-sebastiano" title="Link target outside of Sample">Chapter 8: Sebastiano</span></li>
</ol>
</li>
<li id="toc-li-23"><span href="#/text/ch015#section-8" title="Link target outside of Sample">
</span><ol class="toc"><span href="#/text/ch015#section-8" title="Link target outside of Sample">
</span><li id="toc-li-24"><span href="#/text/ch015#section-8" title="Link target outside of Sample"></span><span href="#/text/ch015#chapter-9-massimo" title="Link target outside of Sample">Chapter 9: Massimo</span></li>
</ol>
</li>
<li id="toc-li-25"><span href="#/text/ch016#section-9" title="Link target outside of Sample">
</span><ol class="toc"><span href="#/text/ch016#section-9" title="Link target outside of Sample">
</span><li id="toc-li-26"><span href="#/text/ch016#section-9" title="Link target outside of Sample"></span><span href="#/text/ch016#chapter-10-stefano" title="Link target outside of Sample">Chapter 10: Stefano</span></li>
</ol>
</li>
<li id="toc-li-27"><span href="#/text/ch017#section-10" title="Link target outside of Sample">
</span><ol class="toc"><span href="#/text/ch017#section-10" title="Link target outside of Sample">
</span><li id="toc-li-28"><span href="#/text/ch017#section-10" title="Link target outside of Sample"></span><span href="#/text/ch017#chapter-11-seb" title="Link target outside of Sample">Chapter 11: Seb</span></li>
</ol>
</li>
<li id="toc-li-29"><span href="#/text/ch018#part-three-west-wales-present-day" title="Link target outside of Sample">Part Three: (West Wales, Present
          Day)</span></li>
<li id="toc-li-30"><span href="#/text/ch019#section-11" title="Link target outside of Sample">
</span><ol class="toc"><span href="#/text/ch019#section-11" title="Link target outside of Sample">
</span><li id="toc-li-31"><span href="#/text/ch019#section-11" title="Link target outside of Sample"></span><span href="#/text/ch019#chapter-12-cristi" title="Link target outside of Sample">Chapter 12: Cristi</span></li>
</ol>
</li>
<li id="toc-li-32"><span href="#/text/ch020#section-12" title="Link target outside of Sample">
</span><ol class="toc"><span href="#/text/ch020#section-12" title="Link target outside of Sample">
</span><li id="toc-li-33"><span href="#/text/ch020#section-12" title="Link target outside of Sample"></span><span href="#/text/ch020#chapter-13-david" title="Link target outside of Sample">Chapter 13: David</span></li>
</ol>
</li>
<li id="toc-li-34"><span href="#/text/ch021#section-13" title="Link target outside of Sample">
</span><ol class="toc"><span href="#/text/ch021#section-13" title="Link target outside of Sample">
</span><li id="toc-li-35"><span href="#/text/ch021#section-13" title="Link target outside of Sample"></span><span href="#/text/ch021#chapter-14-gillian" title="Link target outside of Sample">Chapter 14: Gillian</span></li>
</ol>
</li>
<li id="toc-li-36"><span href="#/text/ch022#section-14" title="Link target outside of Sample">
</span><ol class="toc"><span href="#/text/ch022#section-14" title="Link target outside of Sample">
</span><li id="toc-li-37"><span href="#/text/ch022#section-14" title="Link target outside of Sample"></span><span href="#/text/ch022#chapter-15-david" title="Link target outside of Sample">Chapter 15: David</span></li>
</ol>
</li>
<li id="toc-li-38"><span href="#/text/ch023#section-15" title="Link target outside of Sample">
</span><ol class="toc"><span href="#/text/ch023#section-15" title="Link target outside of Sample">
</span><li id="toc-li-39"><span href="#/text/ch023#section-15" title="Link target outside of Sample"></span><span href="#/text/ch023#chapter-16-cristi" title="Link target outside of Sample">Chapter 16: Cristi</span></li>
</ol>
</li>
<li id="toc-li-40"><span href="#/text/ch024#section-16" title="Link target outside of Sample">
</span><ol class="toc"><span href="#/text/ch024#section-16" title="Link target outside of Sample">
</span><li id="toc-li-41"><span href="#/text/ch024#section-16" title="Link target outside of Sample"></span><span href="#/text/ch024#chapter-17-cristi" title="Link target outside of Sample">Chapter 17: Cristi</span></li>
</ol>
</li>
<li id="toc-li-42"><span href="#/text/ch025#section-17" title="Link target outside of Sample">
</span><ol class="toc"><span href="#/text/ch025#section-17" title="Link target outside of Sample">
</span><li id="toc-li-43"><span href="#/text/ch025#section-17" title="Link target outside of Sample"></span><span href="#/text/ch025#chapter-18-cristi-and-julie" title="Link target outside of Sample">Chapter 18: Cristi and Julie</span></li>
</ol>
</li>
<li id="toc-li-44"><span href="#/text/ch026#part-four-italy-present-day" title="Link target outside of Sample">Part Four: (Italy, Present Day)</span></li>
<li id="toc-li-45"><span href="#/text/ch027#section-18" title="Link target outside of Sample">
</span><ol class="toc"><span href="#/text/ch027#section-18" title="Link target outside of Sample">
</span><li id="toc-li-46"><span href="#/text/ch027#section-18" title="Link target outside of Sample"></span><span href="#/text/ch027#chapter-19-cristi" title="Link target outside of Sample">Chapter 19: Cristi</span></li>
</ol>
</li>
<li id="toc-li-47"><span href="#/text/ch028#section-19" title="Link target outside of Sample">
</span><ol class="toc"><span href="#/text/ch028#section-19" title="Link target outside of Sample">
</span><li id="toc-li-48"><span href="#/text/ch028#section-19" title="Link target outside of Sample"></span><span href="#/text/ch028#chapter-20-seb" title="Link target outside of Sample">Chapter 20: Seb</span></li>
</ol>
</li>
<li id="toc-li-49"><span href="#/text/ch029#section-20" title="Link target outside of Sample">
</span><ol class="toc"><span href="#/text/ch029#section-20" title="Link target outside of Sample">
</span><li id="toc-li-50"><span href="#/text/ch029#section-20" title="Link target outside of Sample"></span><span href="#/text/ch029#chapter-21-cristi" title="Link target outside of Sample">Chapter 21: Cristi</span></li>
</ol>
</li>
<li id="toc-li-51"><span href="#/text/ch030#section-21" title="Link target outside of Sample">
</span><ol class="toc"><span href="#/text/ch030#section-21" title="Link target outside of Sample">
</span><li id="toc-li-52"><span href="#/text/ch030#section-21" title="Link target outside of Sample"></span><span href="#/text/ch030#chapter-22-signor-luce" title="Link target outside of Sample">Chapter 22: Signor Luce</span></li>
</ol>
</li>
<li id="toc-li-53"><span href="#/text/ch031#part-five-the-legacy" title="Link target outside of Sample">Part Five: The Legacy</span></li>
<li id="toc-li-54"><span href="#/text/ch032#section-22" title="Link target outside of Sample">
</span><ol class="toc"><span href="#/text/ch032#section-22" title="Link target outside of Sample">
</span><li id="toc-li-55"><span href="#/text/ch032#section-22" title="Link target outside of Sample"></span><span href="#/text/ch032#chapter-23-cristi" title="Link target outside of Sample">Chapter 23: Cristi</span></li>
</ol>
</li>
<li id="toc-li-56"><span href="#/text/ch033#section-23" title="Link target outside of Sample">
</span><ol class="toc"><span href="#/text/ch033#section-23" title="Link target outside of Sample">
</span><li id="toc-li-57"><span href="#/text/ch033#section-23" title="Link target outside of Sample"></span><span href="#/text/ch033#chapter-24-seb" title="Link target outside of Sample">Chapter 24: Seb</span></li>
</ol>
</li>
<li id="toc-li-58"><span href="#/text/ch034#section-24" title="Link target outside of Sample">
</span><ol class="toc"><span href="#/text/ch034#section-24" title="Link target outside of Sample">
</span><li id="toc-li-59"><span href="#/text/ch034#section-24" title="Link target outside of Sample"></span><span href="#/text/ch034#chapter-25-cristi" title="Link target outside of Sample">Chapter 25: Cristi</span></li>
</ol>
</li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?5b525118